<template>
  <div class="whitelist-card">
    <!-- 搜索和筛选区域 -->
    <div class="order-filter-card">
      <el-form :inline="true" :model="searchForm" class="filter-form">
        <el-form-item>
          <el-input placeholder="订单编号" v-model="searchForm.order_sn" size="small" clearable/>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch" size="small">查询</el-button>
          <el-button @click="onReset" size="small">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 白名单表格 -->
    <el-table ref="whitelistTable" class="whitelist-table mt20" :data="orderList" :border="false" row-key="id">
      <el-table-column prop="order_sn" label="订单编号" align="center"/>
      <el-table-column prop="order_name" label="套餐内容" align="center"/>
      <el-table-column label="操作" align="center">
        <template #default="scope">
          <el-button type="text" @click="getOrderDetails(scope.row)">套餐配置</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class="pagination">
      <el-pagination background layout="total, prev, pager " :total="orderTotal"
                     @current-change="(e)=>{searchForm.page =e;getOrderList}"/>
    </div>
    <Dialog title="套餐详情" ref="orderDetails" width="1000px">
      <div v-if="orderDetails.ip_type==1">
        <el-descriptions :column="2" border v-if="orderDetails.ip_type == 1">
          <el-descriptions-item label="订单编号">{{ orderDetails.order_sn }}</el-descriptions-item>
          <el-descriptions-item label="套餐内容">{{ orderDetails.order_name }}</el-descriptions-item>
          <el-descriptions-item label="套餐地区">
            <el-tag type="danger" size="small">国内</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="计费方式">
            <el-tag v-if="orderDetails.price_type == 0" :key="'price_type_0'" type="success" size="small">包时套餐
            </el-tag>
            <el-tag v-if="orderDetails.price_type == 1" :key="'price_type_1'" type="danger" size="small">包量套餐
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="每日可提" v-if="orderDetails.price_type == 0">
            {{ orderDetails.ip_num }}个
          </el-descriptions-item>
          <el-descriptions-item label="总可提" v-if="orderDetails.price_type == 1">
            {{ orderDetails.ip_num }}个
          </el-descriptions-item>
          <el-descriptions-item label="当天提取数量">
            {{ orderDetails.day_use_num }}个
          </el-descriptions-item>
          <el-descriptions-item label="已使用IP数量">
            {{ orderDetails.ip_use_num }}个
          </el-descriptions-item>
          <el-descriptions-item label="提取记录">
            <el-button type="text" @click.stop.prevent="getUseLogList">查看</el-button>
          </el-descriptions-item>
          <el-descriptions-item label="会话时长">
            {{ orderDetails.validity_minutes }}分钟
          </el-descriptions-item>
          <el-descriptions-item label="套餐有效时间" v-if="orderDetails.price_type==0">
            {{ orderDetails.price_type == 0 ? orderDetails.duration_days + '天' : '不限' }}
          </el-descriptions-item>
          <el-descriptions-item label="密钥">
            <div style="display: flex;justify-content: space-between;align-items: center">
              <span>{{ orderDetails.ip_token }}</span>
              <el-button type="text" @click.stop="resToken">重置</el-button>
            </div>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div v-if="orderDetails.ip_type == 0">
        <el-descriptions :column="2" border>
          <el-descriptions-item label="订单编号">{{ orderDetails.order_sn }}</el-descriptions-item>
          <el-descriptions-item label="套餐内容">{{ orderDetails.order_name }}</el-descriptions-item>
          <el-descriptions-item label="套餐地区">
            <el-tag type="danger" size="small">国外</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="会话时长">
            {{ orderDetails.validity_minutes }}分钟
          </el-descriptions-item>
<!--          <el-descriptions-item label="每日可提" v-if="orderDetails.duration_days != 0">-->
<!--            {{ orderDetails.ip_num }}个-->
<!--          </el-descriptions-item>-->
<!--          <el-descriptions-item label="总可提" v-if="orderDetails.duration_days == 0">-->
<!--            {{ orderDetails.ip_num }}个-->
<!--          </el-descriptions-item>-->
          <el-descriptions-item label="当天提取数量">
            {{ orderDetails.day_use_num }}个
          </el-descriptions-item>
          <el-descriptions-item label="已使用IP数量">
            {{ orderDetails.ip_use_num }}个
          </el-descriptions-item>
          <el-descriptions-item label="提取记录">
            <el-button type="text" @click.stop.prevent="getUseLogList">查看</el-button>
          </el-descriptions-item>
          <el-descriptions-item label="流量" v-if="internet_traffic > 0">
            {{ parseFloat(orderDetails.internet_traffic) }}GB
          </el-descriptions-item>
          <el-descriptions-item label="流量" v-if="internet_traffic == 0">
            不限
          </el-descriptions-item>
          <el-descriptions-item label="套餐有效时间" v-if="orderDetails.duration_days > 0">
            {{ orderDetails.price_type == 0 ? orderDetails.duration_days + '天' : '不限' }}
          </el-descriptions-item>
          <el-descriptions-item label="套餐过期时间" v-if="orderDetails.duration_days > 0">
            {{ orderDetails.validity_day }}
          </el-descriptions-item>
          <el-descriptions-item label="密钥">
            <div style="display: flex;justify-content: space-between;align-items: center">
              <span>{{ orderDetails.ip_token }}</span>
              <el-button type="text" @click.stop="resToken">重置</el-button>
            </div>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <el-descriptions title="白名单" style="margin-top: 20px">
        <template #title>
          <h5>白名单</h5>
        </template>
        <template #extra>
          <h5>
            <el-button type="text" @click="opWhilte">操作白名单</el-button>
          </h5>
        </template>
      </el-descriptions>

      <el-input type="textarea" disabled v-model="orderDetails.white_list"></el-input>
      <span slot="btn" style="display: flex;justify-content: center;margin-top: 10px;">
        <el-button size="small" @click="$refs.orderDetails.onClose()">关闭</el-button>
      </span>
    </Dialog>
    <Dialog title="操作白名单" ref="addWhitelistRef" width="400px">
      <el-form :model="addWhitelistForm" label-width="60px" size="small">
        <el-form-item label="IP">
          <el-input v-model="addWhitelistForm.ip" placeholder="请输入IP" size="small"/>
        </el-form-item>
        <el-form-item label="备注">
          <el-radio-group v-model="addWhitelistForm.op">
            <el-radio label="add">添加</el-radio>
            <el-radio label="del">删除</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="btn" style="display: flex;align-items: center;justify-content: center">
        <div>
          <el-button size="small" @click="$refs.addWhitelistRef.onClose()">取消</el-button>
          <el-button type="primary" size="small" @click="submitAddWhitelist">提交</el-button>
        </div>
      </div>
    </Dialog>
    <Dialog title="提取记录" ref="useLog" width="1000px">
      <el-table :data="useLogList" v-loading="opLoading" height="500px"
                style="width: 100%; margin-bottom: 16px; font-size: 14px;" size="small">
        <el-table-column label="地区" prop="res" align="center"/>
        <el-table-column label="提取格式" prop="fmt" align="center"/>
        <el-table-column label="换行格式" prop="sp" align="center"/>
        <el-table-column label="操作IP" prop="operate_ip" align="center"/>
        <el-table-column label="提取的IP数量" prop="use_num" align="center"/>
        <el-table-column label="提取状态" prop="status" align="center">
          <template #default="scope">
            <span v-if="scope.row.status == 1" style="color:#67c23a;">成功</span>
            <span v-else style="color:#f56c6c;">失败</span>
          </template>
        </el-table-column>
        <el-table-column label="提取时间" prop="createtime" align="center"/>
      </el-table>
      <div class="pagination mt20">
        <el-pagination @current-change="(e)=>{searchLogForm.page =e;getUseLogList}" background
                       layout="total, prev, pager, next" :total="searchLogForm.total" :page-size="15"/>
      </div>
      <span slot="btn" style="display: flex;justify-content: center">
            <el-button size="small" @click="$refs.useLog.onClose();logLoading = true">关闭</el-button>
      </span>
    </Dialog>
  </div>
</template>

<script>
import Dialog from "@/components/Dialog.vue";

export default {
  name: 'Roll',
  components: {Dialog},
  data() {
    return {
      orderList: [],
      orderTotal: 0,
      orderDetails: {},
      maxCount: 5,
      autoReplace: false,
      searchForm: {
        order_sn: '',
        page: 1,
        total: 0,
      },
      selectedRows: [],
      pageSize: 20,
      currentPage: 1,
      addWhitelistForm: {
        ip: '',
        op: 'add',
      },
      logLoading: false,
      logTotal: 0,
      whitelistTotal: 0,
      whitelistPageSize: 10,
      whitelistCurrentPage: 1,
      useLogList: [],
      opLoading: true,
      searchLogForm: {
        order_sn: '',
        page: 1,
        total: 0,
      },
    };
  },
  created() {
    this.getOrderList();
  },
  methods: {
    getUseLogList() {
      this.searchLogForm.order_sn = this.orderDetails.order_sn
      this.$api.extract.extractLogList(this.searchLogForm).then(res => {
        this.useLogList = res.data.data
        
        this.searchLogForm.total = res.data.total
        this.$refs.useLog.onOpen()
        this.opLoading = false
      })

    },
    opWhilte() {
      this.$refs.addWhitelistRef.onOpen()

    },
    resToken() {
      this.$confirm('你确定要重置密钥吗?').then(() => {
        this.$api.packageOrder.resToken({order_sn: this.orderDetails.order_sn}).then((res) => {
          this.$message.success('重置成功')
          this.getOrderDetails(this.orderDetails)
        })
      }).catch(() => {

      })
    },
    getOrderDetails(row) {
      this.$api.packageOrder.packageDetails({order_sn: row.order_sn}).then(res => {
        this.$refs.orderDetails.onOpen()
        this.orderDetails = res.data;
      })
    },
    getOrderList() {
      this.$api.packageOrder.packageList(this.searchForm).then(res => {
        this.orderList = res.data.data;
        this.orderTotal = res.data.total;
      })
    },

    onLogPageChange(page) {
      this.searchLogForm.page = page;
      this.getWhilteListLog({order_sn: this.searchLogForm.order_sn});
    },
    onSearch() {
      // 搜索逻辑
      this.searchForm.page = 1;
      this.getOrderList();
    },
    onReset() {
      this.searchForm = this.$options.data().searchForm
      this.getOrderList();
    },
    submitAddWhitelist() {

      if (!this.addWhitelistForm.ip) {
        this.$message.warning('请输入IP');
        return;
      }
      // IP格式校验
      const ipReg = /^(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)){3}$/;
      if (!ipReg.test(this.addWhitelistForm.ip)) {
        this.$message.warning('请输入正确的IP地址');
        return;
      }
      this.$api.packageOrder.opWhilteList({
        order_sn: this.orderDetails.order_sn,
        ip: this.addWhitelistForm.ip,
        // remark: this.addWhitelistForm.remark,
        op: this.addWhitelistForm.op
      }).then(() => {
        this.$message.success('操作成功');
        this.addWhitelistForm = this.$options.data().addWhitelistForm
        this.$refs.addWhitelistRef.onClose()
        this.getOrderDetails(this.orderDetails)

      });
    },

    formatTime(ts) {
      if (!ts) return '-';
      // 支持10位和13位时间戳
      const t = ts.toString().length === 10 ? ts * 1000 : ts;
      const d = new Date(t);
      return `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')} ${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}:${d.getSeconds().toString().padStart(2, '0')}`;
    },


  },
};
</script>

<style scoped>
.order-filter-card {
  background: #fff;
  box-shadow: 0 4px 24px rgba(38, 130, 255, 0.08);
  padding: 24px 24px 0 24px;
  margin-top: 20px;
}

.whitelist-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(38, 130, 255, 0.08);
  margin-top: 20px;
}

.search-filter-section {
  display: flex;
  align-items: center;
  padding: 20px;
  justify-content: space-between;
  margin-bottom: 20px;
  border-radius: 8px;
}

.search-inputs {
  display: flex;
  align-items: center;
  gap: 12px;
}

.search-input {
  width: 200px;
}

.filter-select {
  width: 150px;
}

.search-buttons {
  display: flex;
  gap: 12px;
}

.whitelist-table {
  border-radius: 0;
  overflow: hidden;
  box-shadow: none;
}

.whitelist-table ::v-deep tr th {
  background: #f5f7fa;
  color: #222;
  font-weight: 600;
  font-size: 15px;
}

.whitelist-table ::v-deep tr {
  transition: background 0.2s;
}

.whitelist-table ::v-deep tr:hover td {
  background: #f0f7ff;
}

.whitelist-table ::v-deep td,
.whitelist-table ::v-deep th {
  padding: 12px 0;
}


.pagination {
  margin-top: 18px;
  text-align: right;
  padding-bottom: 18px;
}

.mt20 {
  margin-top: 20px;
}

.ml10 {
  margin-left: 10px;
}

.whitelist-dialog-small ::v-deep .el-dialog__body {
  font-size: 14px;
}

.whitelist-dialog-small ::v-deep .el-dialog__title {
  font-size: 16px;
}

.whitelist-dialog-small ::v-deep .el-table {
  font-size: 14px;
}

.whitelist-dialog-small ::v-deep .el-table th {
  background: #f5f7fa;
  color: #222;
  font-weight: 600;
  font-size: 14px;
}

.whitelist-dialog-small ::v-deep .el-table td {
  padding: 10px 0;
  font-size: 14px;
}

@media (max-width: 900px) {
  .whitelist-card {
    padding: 12px 4px 0 4px;
  }

  .search-filter-section {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  .search-inputs {
    flex-direction: column;
    gap: 8px;
  }

  .search-input,
  .filter-select {
    width: 100%;
  }
}
</style>
